import POSConfigModule from "@/store/modules/pos-config";
import request, { request2, requestServices } from "@/utils/request";
import PaymentService from "@/services/payment-service";
import { PaymentMethods } from "@/types/db/accounting";
import { TerminalApiRequest } from "@adyen/api-library/lib/src/typings/terminal/terminalApiRequest";
import { TerminalApiResponse } from "@adyen/api-library/lib/src/typings/terminal/terminalApiResponse";

export async function postPOSPayment(
  data: TerminalApiRequest
): Promise<TerminalApiResponse> {
  const controller = new AbortController();
  const signal = controller.signal;
  PaymentService.abortControllers.push(controller);
  let response = null;

  /**
   * We will use the services api for a limited number of groups during
   * a testing period
   */
  if (canUseServicesApi()) {
    response = await requestServices({
      method: "POST",
      url: "v1/terminals/sync",
      data,
      timeout: 0, // No timeout, the proxy will handle it and return a timeout error if needed
      signal: signal,
    });
  } else {
    response = await request2({
      method: "POST",
      url: "api/v1/adyen-pos-pay",
      data,
      timeout: 0, // No timeout, the proxy will handle it and return a timeout error if needed
      signal: signal,
    });
  }
  return response.data;
}

export async function postPaymentStatus(
  data: TerminalApiRequest
): Promise<TerminalApiResponse> {
  const controller = new AbortController();
  const signal = controller.signal;
  PaymentService.abortControllers.push(controller);
  let response = null;

  /**
   * We will use the services api for a limited number of groups during
   * a testing period
   */
  if (canUseServicesApi()) {
    response = await requestServices({
      method: "POST",
      url: "v1/terminals/sync",
      data,
      timeout: 0, // No timeout, the proxy will handle it and return a timeout error if needed
      signal: signal,
    });
  } else {
    response = await request2({
      method: "POST",
      url: "api/v1/adyen-pos-pay",
      data,
      timeout: 0, // No timeout, the proxy will handle it and return a timeout error if needed
      signal: signal,
    });
  }
  return response.data;
}

/**
 *
 */
export async function checkTerminal(uniqueTerminalId?: string): Promise<any> {
  let response: any;
  if (uniqueTerminalId) {
    const params = {
      uniqueTerminalId: uniqueTerminalId,
    };
    response = await request({
      method: "GET",
      url: `/adyen-terminal/${POSConfigModule.groupId}/connected-terminals`,
      params,
    });
  } else {
    response = await request({
      method: "GET",
      url: `/adyen-terminal/${POSConfigModule.groupId}/connected-terminals`,
    });
  }

  return response.data;
}

export async function postPOSRefund(data: {
  bookingId?: number;
  amount: number;
  paymentMethod: PaymentMethods;
  accounting?: number;
  channel: string;
}) {
  const response = await request({
    // baseURL: "http://localhost:8000",
    method: "POST",
    url: `/booking/${data.bookingId}/refund/v2?channel=${data.channel}`,
    data,
    timeout: 0, // No timeout, backend will handle it and return a timeout error if needed
  });

  return response.data;
}

/**
 * Helper function to see if a group shall use the services api for Adyen terminal payments
 */
function canUseServicesApi(): boolean {
  return [
    1, // prod smeetz group
    16383, // dev smeetz group
    16342, // test smeetz group
  ].includes(POSConfigModule.groupId || 0);
}
